import React from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'

const Layout = (props) => {
  return (
    <>
        <Navbar/>
        <div className="container mx-auto">
            {props.children}
        </div>
        <Footer/>
    </>
  )
}

export default Layout